import { getDownloadURL, ref } from 'firebase/storage'

import { storage } from 'config/firebase'
import { SUB_DOMAIN_MAPPINGS } from 'config/subDomain'
import { OrgAssets } from 'context/materialUI/types'

export async function fetchOrganisationAsset(orgId: string, assetName: string) {
	try {
		const assetRef = ref(storage, `laurel/${orgId}/public/images/${assetName}.png`)
		const assetSrc = await getDownloadURL(assetRef)
		return assetSrc
	} catch {
		return null
	}
}

export async function getSubDomainAssets(hostname: string): Promise<OrgAssets> {
	const vendorDomain = hostname.split('.')[0]

	if (!Object.keys(SUB_DOMAIN_MAPPINGS).includes(vendorDomain)) {
		return null
	}
	const orgId = SUB_DOMAIN_MAPPINGS[vendorDomain as keyof typeof SUB_DOMAIN_MAPPINGS]

	const [logoLight, logoDark, iconLight, iconDark, illustrationLogin] = await Promise.all([
		fetchOrganisationAsset(orgId, 'logo-light'),
		fetchOrganisationAsset(orgId, 'logo-dark'),
		fetchOrganisationAsset(orgId, 'icon-light'),
		fetchOrganisationAsset(orgId, 'icon-dark'),
		fetchOrganisationAsset(orgId, 'illustration-login'),
	])

	const allNull = [logoLight, logoDark, iconLight, iconDark, illustrationLogin].every(
		val => val == null
	)

	if (allNull) {
		return null
	}

	const orgAssets: OrgAssets = {
		logo: {
			light: logoLight,
			dark: logoDark,
		},
		icon: {
			light: iconLight,
			dark: iconDark,
		},
		illustration: illustrationLogin,
	}
	return orgAssets
}
